import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for /marketplace. The overview list lives in marketplace.index.tsx
// and the item detail in marketplace.$id.tsx; both render through this Outlet.
// Without an Outlet here, navigating to /marketplace/$id would match the nested
// detail route but still render only this parent — showing the overview again.
export const Route = createFileRoute("/marketplace")({
  component: MarketplaceLayout,
});

function MarketplaceLayout() {
  return <Outlet />;
}
